import React from "react";
import { Link } from "react-router-dom";

import useArticles, { excerpt } from "../hooks/useArticles";

// One component covers both the full /novinky list and the shorter preview
// on the homepage; the Gatsby site had two near-identical copies.
const Articles = ({ preview = false, limit }) => {
  const { articles, loading, error } = useArticles(limit);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader" />
      </div>
    );
  }

  if (error) {
    return <div className="article-error">{error}</div>;
  }

  if (!articles.length) {
    return <div className="article-error">Zatím zde nejsou žádné novinky.</div>;
  }

  return (
    <div className={`article-list${preview ? " articles-preview-list" : ""}`}>
      {articles.map((post) => {
        const to = `/novinky/${encodeURIComponent(post.title)}`;

        return (
          <div
            className={[
              "article-container",
              preview ? "articles-preview" : "",
              post.featured ? "is-featured" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            key={post.title}
          >
            <article className="article-item">
              <header>
                {post.imageUrl && (
                  <div className="thumbnail-image">
                    <Link to={to} state={{ post }}>
                      <img
                        src={post.imageUrl}
                        alt={`náhledový obrázek ke článku ${post.title}`}
                        loading="lazy"
                      />
                    </Link>
                  </div>
                )}
                <p className="article-title-container">
                  <Link
                    className={`article-title${
                      preview ? " articles-preview-title" : ""
                    }`}
                    to={to}
                    state={{ post }}
                  >
                    {post.title}
                  </Link>
                  <span
                    className={`article-date${
                      preview ? " articles-preview-date" : ""
                    }`}
                  >
                    {post.date}
                  </span>
                </p>
              </header>
              <p
                className={`article-text${
                  preview ? " articles-preview-text" : ""
                }`}
              >
                {excerpt(post.content, preview ? 250 : 300)}
                <br />
                <br />
                <Link className="btn" to={to} state={{ post }}>
                  více
                </Link>
              </p>
            </article>
          </div>
        );
      })}
    </div>
  );
};

export default Articles;
